export default "__VITE_ASSET__Cnawuf2Y__"